<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propSurveyId: { type: Number, required: false, default: null },
        }
    })
    export default class SurveyCloserDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get surveyId(): number | null { return this.$props.propSurveyId as number; }

        stopSurvey()
        {
            this.$emit('stop-survey', this.surveyId);
        }  

        close()
        {
            this.$emit('close-dialog');
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Closing a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            You're about to close the survey.
                        </p><br />
                    </div>

                    <div class="modal-footer">
                        <button @click="stopSurvey" type="button" class="btn btn-primary">Close the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>